module.exports = __webpack_public_path__ + "static/media/ErrorPageBg.85ee1058.jpg";